import { TFunction } from 'i18next';
import { useRouter } from 'next/router';
import { Control, FieldErrors } from 'react-hook-form';

import React, { RefObject, forwardRef } from 'react';

import { FormValues as PostFormValues } from 'components/PostForm/PostForm';
import { FormValues as ReplyEditorFormValues } from 'components/ReplyEditorContext/ReplyEditorContext';
import DocumentEditor from 'components/new/Posts/DocumentEditor/DocumentEditor';
import ReplyingContext from 'components/new/Posts/ReplyingContext/ReplyingContext';

type AllFormValues = PostFormValues | ReplyEditorFormValues;

export interface RichTextEditorHandle {
  reset: () => void;
}

interface RichTextEditorProps {
  t: TFunction;
  isEditing?: boolean;
  showTitle?: boolean;
  cancelEdit?: () => void;
  control: Control<AllFormValues>;
  errors: FieldErrors<AllFormValues>;
  setValue: (name: string, value: unknown) => void;
  onSubmit?: () => void;
  isSubmitting?: boolean;
  contentPlaceholder?: string;
  replyPlaceholder?: string;
  closeReplyOnComment?: () => void;
  mentionsTextAreaRef: RefObject<HTMLTextAreaElement | HTMLInputElement>;
  // eslint-disable-next-line react/no-unused-prop-types
  postType: 'post' | 'reply';
  // eslint-disable-next-line react/no-unused-prop-types
  spaceId?: string; // this is used in the DocumentEditor, linter doesn't recognize that
}

const RichTextEditor = forwardRef<RichTextEditorHandle, RichTextEditorProps>((props) => {
  const router = useRouter();
  return (
    <ReplyingContext
      closeReplyOnComment={props.closeReplyOnComment}
      isEditing={props.isEditing}
      replyingTo={props.replyPlaceholder}
    >
      <DocumentEditor
        {...props}
        placeholder={props.contentPlaceholder}
        spaceId={props.spaceId || (router?.query?.spaceId as string)}
      />
    </ReplyingContext>
  );
});

RichTextEditor.displayName = 'RichTextEditor';

export default RichTextEditor;
